<template>
    <div>
        <svg width="74" height="24" viewBox="0 0 74 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path id="Rectangle 4014" d="M74 0H0L7.5 12L0 24H74V0Z" fill="#F3F4F6" />
            <text class="mfp-HelveticaNowMTMicro-Medium-11" x="50%" y="50%" dominant-baseline="middle" text-anchor="middle" fill="#1459B3">
                Internal
            </text>
        </svg>
    </div>
</template>
<script>
import 'mpl-css/lib/assets/global/mfpfonts/fonts.scss';
import "mpl-css/lib/assets/global/variables/colors.scss";
export default {

}
</script>
